module.exports = __webpack_public_path__ + "static/media/neu-logo.958de662.png";